import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Buyer from '../../../core/models/Buyer';
import tableColumnTextFilterConfig from '../../../utils/searchUtil';

interface IProps {
  isLoading: boolean;
  buyers: Buyer[] | undefined;
}

const columns: ColumnsType<Buyer> = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Buyer>(),
    onFilter: (value, record) => {
      return record.name.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    sorter: (a, b) => a.email.localeCompare(b.email),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Buyer>(),
    onFilter: (value, record) => {
      return record.email.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'NIC or Passport No',
    dataIndex: ['uniqueIdentifierType', 'type'],
    key: 'uniqueIdentifierType',
    sorter: (a, b) => a.uniqueIdentifierType.type.localeCompare(b.uniqueIdentifierType.type),
  },
  {
    title: 'NIC/Passport No',
    dataIndex: 'uniqueIdentifier',
    key: 'uniqueIdentifier',
    sorter: (a, b) => a.uniqueIdentifier.localeCompare(b.uniqueIdentifier),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Buyer>(),
    onFilter: (value, record) => {
      return record.uniqueIdentifier
        .toString()
        .toLowerCase()
        .includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'Phone Number',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Buyer>(),
    onFilter: (value, record) => {
      return record.phoneNumber.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'City',
    dataIndex: 'city',
    key: 'city',
    sorter: (a, b) => a.city.localeCompare(b.city),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Buyer>(),
    onFilter: (value, record) => {
      return record.city.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'Category',
    dataIndex: ['buyerCategory', 'category'],
    key: 'category',
    sorter: (a, b) => a.buyerCategory.category.localeCompare(b.buyerCategory.category),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Buyer>(),
    onFilter: (value, record) => {
      return record.buyerCategory.category
        .toString()
        .toLowerCase()
        .includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'Status',
    dataIndex: ['status', 'name'],
    key: 'status',
    sorter: (a, b) => a.status.id - b.status.id,
    filters: [
      {
        text: 'Approved',
        value: '2',
      },
      {
        text: 'Rejected',
        value: '3',
      },
    ],
    onFilter: (value, record) => {
      return record.status.id.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  },
];

const BuyerTable: React.FC<IProps> = ({ isLoading, buyers }) => {
  const navigate = useNavigate();

  return (
    <Table
      dataSource={buyers}
      columns={columns}
      rowKey='id'
      loading={isLoading}
      size='small'
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            navigate(`/users/buyers/${record.id}`);
          },
        };
      }}
    />
  );
};

export default BuyerTable;
